import React from "react";

export default function EmptyCart() {
  return (
    <div className="emptyCOntainer">
      <div>
        <div>
          <h1>Your cart is empty</h1>
        </div>
      </div>
    </div>
  );
}
